import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import ImgPreview from '../imgPreview';
import { EmpServiceAPIActions } from '@/services/empService';
import { appEnvConfig } from '@/configs/appConfigs';
import baseAPIService from '@/services/base/baseAPIService';
import { noop } from '@/util';
import { Functions } from '@/library/utils/functions';
@Component({
  components: {},
})
export default class Upload extends Vue {
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /* 图片上传地址 */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  // element form component inject param
  @Inject({ default: '' })
    elForm;

  @Inject({ default: '' })
    elFormItem;

  // 图片地址
  @Prop()
    img;

  // 是否显示删除
  @Prop({ default: true })
    noDelete: boolean;

  // 是否是自行上传图标
  @Prop({ default: false })
    typeIcon: boolean;

  @Prop()
    value;


  // 是否不可编辑
  @Prop({ default: false })
    disabled: boolean;

  // 最大
  @Prop({ default: null })
    maxSize: number;

  // 上传的是否是文件列表
  @Prop({ default: false })
    fileList: boolean;

  // 多文件上传的长度限制
  @Prop({ default: 10 })
    maxLen: number;

  // 多图片上传时 是否可以切换图片【有选中样式】
  @Prop({ default: false })
    canSwitch: boolean;

  // 图片选中index
  @Prop({ default: 0 })
    selectedIndex: number;

  // 排序
  @Prop({ default: false })
    sort: boolean;

  @Prop({ default: false })
    isTagBorderRadius: boolean;

  // TODO 历史代码过于臃肿，需优化
  @Watch('img', { immediate: true })
  onImgChange(n, o) {
    if (n !== o && JSON.stringify(n) !== JSON.stringify(0)) {
      this.imgUrl = n ? n : this.fileList ? [] : '';
    }
  }

  @Watch('value', { immediate: true })
  onValueChange(n, o) {
    if (n !== o && JSON.stringify(n) !== JSON.stringify(0)) {
      this.imgUrl = n ? n : this.fileList ? [] : '';
    }
  }

  // 顺序的调整，页需把值传出去
  @Watch('imgUrl', { immediate: true })
  onImgUrlChange(n, o) {
    if (n !== o && JSON.stringify(n) !== JSON.stringify(0)) {
      this.$emit('input', this.imgUrl);
    }
  }

  get uploadDisabled() {
    return this.disabled || (this.elForm || {}).disabled;
  }

  imgUrl = null;

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  deleteImg() {
    this.imgUrl = '';
  }

  /**
   * 图片上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  onBeforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt1000KB = file.size / 1024 < (this.maxSize || 500);
    const isSVG = file.type === 'image/svg+xml';
    if (this.typeIcon) {
      if (!isSVG && !isPNG) {
        this.$message.error('上传图片只支持 SVG/PNG 格式!');
      }
    } else {
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
      }
    }

    if (!isLt1000KB) {
      this.$message.error(`上传图片大小不能超过 ${(this.maxSize || 500) === 1024 ? '1M' : `${this.maxSize}KB`}!`);
    }
    return this.typeIcon ? (isSVG || isPNG) && isLt1000KB : (isJPG || isPNG || isGIF) && isLt1000KB;
  }

  /**
   * 点击图片
   * @param index 点击的img index
   */
  selectChange(index) {
    this.$emit('update:selectedIndex', index);
    this.$emit('selectChange', index);
  }

  /**
   * 图片上传成功时的处理
   * @param res
   */
  uploadImgSuccess(res: HttpAPIRetItem<any>) {
    this.imgUrl = res.content;
    this.$emit('imgUploadSuccess', res);
    this.$emit('input', this.imgUrl);
  }

  onUploadImgSuccess(res: HttpAPIRetItem<any>) {
    if (this.imgUrl.length === 0) {
      this.$set(this.imgUrl, 0, res.content);
    } else {
      this.imgUrl.push(res.content);
    }
    this.$emit('imgUploadSuccess', this.imgUrl, res.content);
    this.$emit('input', this.imgUrl);
  }

  /**
   * 上传失败提示
   * @param err
   */
  uploadImgError(err) {
    const result = JSON.parse(err.message);
    if (result.message) {
      this.$message.error(result.message);
    }
  }

  onDeletePic(index?) {
    if (index !== undefined && index !== null) {
      this.imgUrl = this.imgUrl.filter((v, i) => i !== index);
    } else {
      this.imgUrl = '';
    }
    if (this.selectedIndex === index) {
      this.$emit('update:selectedIndex', 0);
    }
    this.$emit('delete', this.imgUrl, index);
    this.$emit('input', this.imgUrl);
  }

  onMagnifyPic(index?) {
    ImgPreview.open({ img: index !== undefined && index !== null ? this.imgUrl[index] : this.imgUrl }).then(noop, noop);
  }

  onSort() {
    this.$emit('sort', this.imgUrl);
  }
}
